import Heading from 'components/Basic/Heading/Heading';
import { ProductRatingBreakdown } from 'components/Blocks/Reviews/ProductRatingBreakdown';
import { StarRating } from 'components/Blocks/Reviews/StarRating';
import { ratingToPercent } from 'hooks/reviews/useReviewTransform';
import useTranslation from 'next-translate/useTranslation';
import { ReviewsSummary } from 'types/review';

type ProductReviewsHeaderProps = {
    summary: ReviewsSummary;
};

export const ProductReviewsHeader = ({ summary }: ProductReviewsHeaderProps) => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col justify-start space-y-4 border-b-2 border-grayLight pt-4 pb-4 pt-6 lg:flex-row lg:justify-between lg:space-x-6 lg:space-y-0 lg:pt-6 lg:pb-6 vl:border-[#e1e1e1]">
            <Heading className="hidden basis-1/5 vl:block" type="h2">
                {t('Reviews')}
            </Heading>
            <div className="flex basis-2/5 flex-row justify-around lg:justify-start lg:space-x-24">
                <div className="justify-stretch flex flex-col items-center space-y-2">
                    <span className="text-h3 font-bold">{Math.round(ratingToPercent(summary.averageRating))}%</span>
                    <StarRating rating={summary.averageRating} type="big" />
                    <span>{t('{{ count }} reviews', { count: summary.totalCount })}</span>
                </div>
                <ProductRatingBreakdown breakdowns={summary.ratingBreakdowns} />
            </div>

            <div className="flex basis-2/5 flex-col justify-end">
                {t(
                    'Reviews taken from heureka.cz; Tescoma does not verify whether they come from a consumer who has used or purchased the product.',
                )}
            </div>
        </div>
    );
};
